import React, { useContext, useEffect } from 'react'
import { Link } from 'react-router-dom'

import { useDebounce, useSetState } from '@campaignhub/react-hooks'
import {
  Box, Button, InputSearch, ListItem,
} from '@campaignhub/suit-theme'
import PageContext from '@contexts/pageContext'

const defaultState = {
  searchFilter: '',
}

const Tools = () => {
  const { callbacks: { searchZoneFilter } } = useContext(PageContext)

  const [state, setState] = useSetState(defaultState)
  const { searchFilter } = state
  const debouncedSearchFilter = useDebounce(searchFilter, 300)

  useEffect(() => {
    searchZoneFilter(debouncedSearchFilter)
  }, [debouncedSearchFilter])

  return (
    <ListItem
      boxProps={{
        borderBottom: '1px solid',
        padding: 'large',
      }}
      flexDirection="column"
      disableHover
    >
      <Box flexDirection="column" paddingBottom="medium">
        <InputSearch
          onChange={e => setState({ searchFilter: e.target.value })}
          placeholder="Search Zone"
          value={searchFilter}
        />
      </Box>
      <Box flexDirection="row">
        <Box flexDirection="column">
          <Link to="new" style={{ textDecoration: 'none' }}>
            <Button buttonStyle="secondary" size="medium">
              Create New Zone
            </Button>
          </Link>
        </Box>
      </Box>
    </ListItem>
  )
}

Tools.propTypes = {}

export default Tools
